import {gql} from "@apollo/client";


export const DEACTIVATE_DEPOSIT_LIMIT = gql`mutation DeactivateActiveDepositLimitMutation($limitId: Int!){
    deactivateLimit (
        limitId: $limitId
)
    {
        id
    }
}`;